import { ReactNode } from "react";
import { SanitizeHTML } from "../../global/SanitizeHTML";

interface ITitleSlide {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

export default function TitleSlide({ title, subtitle = '', children }: ITitleSlide) {
  return (
    <section
      data-background-image="/images/global/logo_tec_bottom_branding.png"
      data-background-size="250px"
      data-background-repeat="no-repeat"
      data-background-position="bottom left"
      data-background-color="#002855"
    >
      <h2>{title}</h2>
      <SanitizeHTML html={subtitle}></SanitizeHTML>
      {children}
    </section>
  );
}
